var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83271 5.78989C2.60171 7.43959 1.28617 9.66698 1.28617 12.0695C1.28617 14.472 2.60171 16.6994 4.83271 18.3491C7.06356 19.9987 10.176 21.0384 13.6419 21.0384C17.1079 21.0384 20.2203 19.9987 22.4512 18.3491C24.6822 16.6994 25.9977 14.472 25.9977 12.0695C25.9977 9.66698 24.6822 7.43959 22.4512 5.78989C20.2203 4.1403 17.1079 3.10062 13.6419 3.10062C10.176 3.10062 7.06356 4.1403 4.83271 5.78989ZM4.06801 4.75574C6.54183 2.92649 9.92883 1.81445 13.6419 1.81445C17.3551 1.81445 20.7421 2.92649 23.2159 4.75574C25.6895 6.58488 27.2839 9.16347 27.2839 12.0695C27.2839 14.9755 25.6895 17.5541 23.2159 19.3832C20.7421 21.2125 17.3551 22.3245 13.6419 22.3245C9.92883 22.3245 6.54183 21.2125 4.06801 19.3832C1.59435 17.5541 0 14.9755 0 12.0695C0 9.16347 1.59435 6.58488 4.06801 4.75574Z",
    fill: "url(#paint0_linear_5580_23060)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6292 9.12684L18.9581 15.1788C18.0655 15.8829 16.5247 15.3915 16.5247 14.4026L16.5247 1.36686C16.5247 0.377956 18.0661 -0.113401 18.9581 0.590685L26.6292 6.64264C27.5025 7.33125 27.5025 8.4378 26.6292 9.12684Z",
    fill: "url(#paint1_linear_5580_23060)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8221 9.00825L6.8833 14.4825C6.07587 15.1194 4.68214 14.6749 4.68214 13.7804L4.68214 1.98903C4.68214 1.09453 6.07638 0.650076 6.8833 1.28695L13.8221 6.76119C14.612 7.38406 14.612 8.38498 13.8221 9.00825Z",
    fill: "#1A2037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2866 6.1724C14.8393 6.60824 15.1646 7.22166 15.1646 7.8846L14.2866 6.1724ZM14.2866 6.1724L7.34796 0.698259C7.34792 0.698228 7.348 0.698291 7.34796 0.698259C6.71329 0.197416 5.89229 0.145108 5.25226 0.349207C4.62739 0.548473 3.93214 1.09257 3.93214 1.98906L3.93214 13.7804C3.93214 14.6768 4.62708 15.221 5.25204 15.4203C5.89217 15.6244 6.71297 15.5721 7.34778 15.0714L14.2866 9.5971C14.8392 9.16109 15.1646 8.54757 15.1646 7.8846M13.3575 8.41949C13.3575 8.41949 13.3575 8.41948 13.3575 8.41949C13.5949 8.23223 13.6646 8.03362 13.6646 7.8846C13.6646 7.73561 13.5949 7.53719 13.3577 7.35016L6.41876 1.8758C6.24652 1.73985 5.96677 1.69578 5.70799 1.7783C5.58556 1.81735 5.50693 1.87366 5.46733 1.91719C5.43402 1.9538 5.43214 1.97413 5.43214 1.98906L5.43214 13.7804C5.43214 13.7955 5.43405 13.8158 5.46733 13.8524C5.5069 13.8959 5.58546 13.9522 5.70783 13.9912C5.96639 14.0737 6.24613 14.0298 6.41876 13.8937C6.41874 13.8937 6.41879 13.8937 6.41876 13.8937L13.3575 8.41949Z",
    fill: "url(#paint2_linear_5580_23060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23060",
    x1: 22.1826,
    y1: 3.52981,
    x2: 5.10227,
    y2: 20.6101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5580_23060",
    x1: 27.2842,
    y1: 7.88474,
    x2: 12.7605,
    y2: 7.8848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5580_23060",
    x1: 39.6634,
    y1: 7.88494,
    x2: 4.68214,
    y2: 7.88475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b0872bd20f96dcd5f1f2b8928342757d.svg";
export { ForwardRef as ReactComponent };